import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// "← Admin" back link to the Admin Tools page. Used at the top of the
// Dialpad pages (which now live inside the Admin Tools section).
export default function AdminBackLink({ sx }) {
  return (
    <Box sx={{ flexShrink: 0, ...sx }}>
      <Link
        component={RouterLink}
        to="/admin"
        underline="hover"
        sx={{
          display: "inline-flex", alignItems: "center", gap: 0.5,
          fontSize: "0.8rem", fontWeight: 600, color: "#64748b",
          "&:hover": { color: "#334155" },
        }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: 12 }} /> Admin
      </Link>
    </Box>
  );
}
